import { render, staticRenderFns } from "./SetDepartment.vue?vue&type=template&id=e91ff2e2&"
import script from "./SetDepartment.vue?vue&type=script&lang=js&"
export * from "./SetDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports